/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TriggerResponse } from "./TriggerResponse";

/**
 * A template with its wording and triggers, for the editor.
 */
export type MessageTemplateDetail = {
  id: number;
  org_id: number;
  name: string;
  email_subject?: string | null;
  email_body?: string | null;
  email_format?: MessageTemplateDetail.email_format;
  email_html?: string | null;
  sms_body?: string | null;
  promotional?: boolean;
  modified_at: string;
  triggers: Array<TriggerResponse>;
};

export namespace MessageTemplateDetail {
  export enum email_format {
    EDITOR = "editor",
    HTML = "html",
  }
}
